<script setup lang="ts">
import { PencilSquareIcon } from '@heroicons/vue/24/outline'
defineProps(['params'])
</script>

<template>
  <div class="flex items-center gap-2 w-full">
    <button
      class="btn btn-ghost btn-sm"
      title="Modifier"
      @click="params.onClickEdit(params.data)"
    >
      <PencilSquareIcon class="w-4 h-4" />
    </button>
  </div>
</template>
